import React from 'react'
import { Handle, Position } from 'reactflow'

// Trigger Node (Purple) - Starting point of workflows
export const TriggerNode = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg border-2 bg-purple-50 border-purple-400 min-w-[180px] ${selected ? 'ring-2 ring-purple-600' : ''}`}>
      <Handle type="source" position={Position.Right} className="w-3 h-3 bg-purple-600" />
      <div className="flex items-center gap-2">
        <span className="text-2xl">{data.icon || '🎯'}</span>
        <div>
          <div className="text-xs font-semibold text-purple-700 uppercase">Trigger</div>
          <div className="text-sm font-medium text-gray-800">{data.label}</div>
        </div>
      </div>
      {data.description && (
        <div className="text-xs text-gray-600 mt-1">{data.description}</div>
      )}
    </div>
  )
}

// Action Node (Blue) - Performs actions
export const ActionNode = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg border-2 bg-blue-50 border-blue-400 min-w-[180px] ${selected ? 'ring-2 ring-blue-600' : ''}`}>
      <Handle type="target" position={Position.Left} className="w-3 h-3 bg-blue-600" />
      <Handle type="source" position={Position.Right} className="w-3 h-3 bg-blue-600" />
      <div className="flex items-center gap-2">
        <span className="text-2xl">{data.icon || '⚡'}</span>
        <div>
          <div className="text-xs font-semibold text-blue-700 uppercase">Action</div>
          <div className="text-sm font-medium text-gray-800">{data.label}</div>
        </div>
      </div>
      {data.description && (
        <div className="text-xs text-gray-600 mt-1">{data.description}</div>
      )}
    </div>
  )
}

// Condition Node (Yellow) - Branching logic
export const ConditionNode = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg border-2 bg-yellow-50 border-yellow-400 min-w-[180px] ${selected ? 'ring-2 ring-yellow-600' : ''}`}>
      <Handle type="target" position={Position.Left} className="w-3 h-3 bg-yellow-600" />
      <Handle type="source" position={Position.Right} id="true" style={{ top: '30%' }} className="w-3 h-3 bg-green-500" />
      <Handle type="source" position={Position.Right} id="false" style={{ top: '70%' }} className="w-3 h-3 bg-red-500" />
      <div className="flex items-center gap-2">
        <span className="text-2xl">{data.icon || '🔀'}</span>
        <div>
          <div className="text-xs font-semibold text-yellow-700 uppercase">Condition</div>
          <div className="text-sm font-medium text-gray-800">{data.label}</div>
        </div>
      </div>
      <div className="flex justify-between mt-2 text-xs">
        <span className="text-green-600 font-medium">✓ True</span>
        <span className="text-red-600 font-medium">✗ False</span>
      </div>
    </div>
  )
}

// Delay Node (Orange) - Wait periods
export const DelayNode = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg border-2 bg-orange-50 border-orange-400 min-w-[180px] ${selected ? 'ring-2 ring-orange-600' : ''}`}>
      <Handle type="target" position={Position.Left} className="w-3 h-3 bg-orange-600" />
      <Handle type="source" position={Position.Right} className="w-3 h-3 bg-orange-600" />
      <div className="flex items-center gap-2">
        <span className="text-2xl">{data.icon || '⏰'}</span>
        <div>
          <div className="text-xs font-semibold text-orange-700 uppercase">Delay</div>
          <div className="text-sm font-medium text-gray-800">{data.label}</div>
        </div>
      </div>
      {data.delay && (
        <div className="text-xs text-gray-600 mt-1">
          Wait: {data.delay} {data.delayUnit || 'minutes'}
        </div>
      )}
    </div>
  )
}

// Data Node (Green) - Database operations
export const DataNode = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg border-2 bg-green-50 border-green-400 min-w-[180px] ${selected ? 'ring-2 ring-green-600' : ''}`}>
      <Handle type="target" position={Position.Left} className="w-3 h-3 bg-green-600" />
      <Handle type="source" position={Position.Right} className="w-3 h-3 bg-green-600" />
      <div className="flex items-center gap-2">
        <span className="text-2xl">{data.icon || '💾'}</span>
        <div>
          <div className="text-xs font-semibold text-green-700 uppercase">Data</div>
          <div className="text-sm font-medium text-gray-800">{data.label}</div>
        </div>
      </div>
      {data.description && (
        <div className="text-xs text-gray-600 mt-1">{data.description}</div>
      )}
    </div>
  )
}

// End Node (Gray) - Workflow termination
export const EndNode = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg border-2 bg-gray-100 border-gray-400 min-w-[180px] ${selected ? 'ring-2 ring-gray-600' : ''}`}>
      <Handle type="target" position={Position.Left} className="w-3 h-3 bg-gray-600" />
      <div className="flex items-center gap-2">
        <span className="text-2xl">{data.icon || '🛑'}</span>
        <div>
          <div className="text-xs font-semibold text-gray-700 uppercase">End</div>
          <div className="text-sm font-medium text-gray-800">{data.label || 'Stop Workflow'}</div>
        </div>
      </div>
    </div>
  )
}
